import { create } from 'zustand';

/** Whether the Custom layout is being arranged on screen (Settings → Appearance → Layout → Arrange). */
interface LayoutEditor {
  editing: boolean;
  start: () => void;
  stop: () => void;
}

export const useLayoutEditor = create<LayoutEditor>()((set) => ({
  editing: false,
  start: () => set({ editing: true }),
  stop: () => set({ editing: false }),
}));
